import { memo } from 'react'
import { MasterSelector } from 'redux/selector';
import OptionMessage from '../OptionMessage';

const Broker = (props) => {
  return <OptionMessage {...props} selector={MasterSelector.brokerOptions} />
}

export default memo(Broker);